import React, { useEffect, useContext, useRef, useState } from 'react';
import { useLocation, Link } from "react-router-dom";
import videosData from '/data/videosData.json';
import PanelVideo from "/components/PanelVideo.jsx";
import { useLanguage } from "/components/utils/LanguageContext";




export default function Fresque() {
  const location = useLocation();
  const [categories, setCategories] = useState([]);
  const [currentVideoKey, setCurrentVideoKey] = useState(null);
  const [isPanelVisible, setIsPanelVisible] = useState(false);
  const [isVideoVisible, setIsVideoVisible] = useState(false);
  const panelRef = useRef(null);
  const { language } = useLanguage();

  useEffect(() => {
    if (location.pathname === "/fresque") {
      setTimeout(() => {
        setIsPanelVisible(true); 
      }, 1000);
    } else {
      setIsPanelVisible(false);
      setIsVideoVisible(false);
    }
    setCategories(videosData)
  }, [location]);


  const handleVideoSelect = (categoryIndex, videoIndex) => {
    const video = videosData[categoryIndex].videos[videoIndex];
    const videoKey = video.order;
    setIsPanelVisible(false);
    setTimeout(() => {
      setIsVideoVisible(true);
    }, 500);
    setCurrentVideoKey(videoKey);
  };

  const handleCloseVideo = () => {
    setTimeout(() => {
        setIsPanelVisible(true); 
        setIsVideoVisible(false);
      }, 100);
      setTimeout(() => {
        setCurrentVideoKey(null);
      }, 1000);
  };

  const handleNextVideo = (nextVideoKey) => {
    setCurrentVideoKey(nextVideoKey);
  };


  return (
    <>
    <div
      id="fresque_panel"
      ref={panelRef}
      className={`absolute h-full w-full overflow-scroll bottom-0 left-0 w-1/2 h-auto flex-wrap justify-between flex-col items-start px-6 md:px-10 pt-24 md:pt-32 pb-10 bg-second shadow-[rgba(100,100,111,0.2)_0px_7px_29px_0px] transition-all ease-in-out duration-[1000ms] z-10 ${
        isPanelVisible ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}>
      <div className="flex flex-col gap-5 w-full">
        {categories.map((category, categoryIndex) => (
          <div key={categoryIndex} className="flex flex-col gap-1">
            <h2 className="font-['md-avenir'] text-xl md:text-2xl text-first mt-6">
                {language === "EN" ? category.enTitle : category.frTitle}
            </h2>
            <div className='flex flex-col gap-2 w-full'>
                {category.videos.map((video, videoIndex) => (
                <Link 
                  key={videoIndex}
                  onClick={() => handleVideoSelect(categoryIndex, videoIndex)}
                  state={{ videoData: video }}
                  className="cursor-pointer flex group justify-between items-center border-first border-b transition-all ease-in-out duration-300 text-base no-underline py-2" 
                >
                  <p className="font-['md-avenir'] text-sm md:text-base text-first_alt group-hover:font-bold group-hover:text-first group-hover:translate-x-[5px] transition-all transform ease-in-out duration-300">
                    {language === "EN" ? video.enTitle : video.frTitle}
                  </p>
                  <svg
                    width="11"
                    height="11"
                    viewBox="0 0 11 11"
                    xmlns="http://www.w3.org/2000/svg"
                    className="fill-first text-base rotate-180 transition-all ease-in-out duration-300 group-hover:translate-x-[0px] -translate-x-[5px]"
                  >
                    <path d="M8.68907 1.68568L4.56454 5.50492L8.68907 9.32416C9.10364 9.70805 9.10364 10.3282 8.68907 10.7121C8.27449 11.096 7.60478 11.096 7.19021 10.7121L2.31093 6.19396C1.89636 5.81007 1.89636 5.18993 2.31093 4.80604L7.19021 0.287919C7.60478 -0.0959731 8.27449 -0.0959731 8.68907 0.287919C9.09301 0.671812 9.10364 1.30179 8.68907 1.68568Z" />
                  </svg>
                </Link>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
    <div
      className={`absolute h-full w-full overflow-scroll bottom-0 left-0 w-1/2 h-auto flex-wrap justify-between flex-col items-start px-6 md:px-10 pt-24 md:pt-32 pb-10 bg-second shadow-[rgba(100,100,111,0.2)_0px_7px_29px_0px] transition-all ease-in-out duration-[1000ms] z-10 ${
        isVideoVisible ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}>
        <PanelVideo
            videoKey={currentVideoKey}
            onClose={handleCloseVideo}
            onNextVideo={handleNextVideo}
        />
    </div>
    </>
  );
}